import React, { useState, useEffect } from 'react';
import Navigation from './Navigation';
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Header = () => {
    const [logo, setLogo] = useState(require('../../images/soltarc-logo.png'));
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language || "es");

    const handleSearchToggle = () => setIsSearchActive(!isSearchActive);
    const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);
    const handleMenuClose = (e) => {
        setIsMenuOpen(false);
        // mobilenav.js abre el drawer añadiendo `.active` al header; lo quitamos para cerrarlo
        e.currentTarget.closest('.mobile-sider-drawer-menu')?.classList.remove('active');
    };

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            const stickyheader = document.querySelector('.sticky-header');
            if (offset >= 100) {
                stickyheader.classList.add('is-fixed', 'color-fill');
            } else {
                stickyheader.classList.remove('is-fixed', 'color-fill');
            }
        };

        window.addEventListener('scroll', handleScroll);

        window.updateTopMostParent = (logopath) => {
            setLogo(logopath);
        };

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLanguageChange = (selectedLanguage) => {
        setLanguage(selectedLanguage);
        i18n.changeLanguage(selectedLanguage);
    };

    return (
        <header className="site-header nav-wide nav-transparent mobile-sider-drawer-menu">
            <div className="sticky-header main-bar-wraper navbar-expand-lg">
                <div className="main-bar">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0 32px' }}>

                        {/* LEFT — Logo */}
                        <div className="logo-header" style={{ flexShrink: 0 }}>
                            <div className="logo-header-inner logo-header-one">
                                <NavLink to={"/"}>
                                    <img src={logo} alt="SoltArc" style={{ maxHeight: 60 }} />
                                </NavLink>
                            </div>
                        </div>

                        {/* RIGHT — Nav + Language */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

                            {/* Mobile hamburger */}
                            <button
                                id="mobile-side-drawer"
                                className={`navbar-toggler ${isMenuOpen ? '' : 'collapsed'}`}
                                onClick={handleMenuToggle}
                            >
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar icon-bar-first" />
                                <span className="icon-bar icon-bar-two" />
                                <span className="icon-bar icon-bar-three" />
                            </button>

                            {/* Navigation links */}
                            <div className={`header-nav nav-dark navbar-collapse ${isMenuOpen ? 'show' : 'collapse'}`}>
                                <button
                                    type="button"
                                    className="mobile-nav-close"
                                    aria-label="Cerrar menú"
                                    onClick={handleMenuClose}
                                >
                                    &times;
                                </button>
                                <Navigation />
                            </div>

                            {/* Language selector */}
                            <div className="lang-switch" role="group" aria-label="Seleccionar idioma">
                                <button
                                    type="button"
                                    className={`lang-btn ${language === 'es' ? 'is-active' : ''}`}
                                    onClick={() => handleLanguageChange('es')}
                                    aria-pressed={language === 'es'}
                                >
                                    ES
                                </button>
                                <span className="lang-sep" aria-hidden="true">/</span>
                                <button
                                    type="button"
                                    className={`lang-btn ${language === 'en' ? 'is-active' : ''}`}
                                    onClick={() => handleLanguageChange('en')}
                                    aria-pressed={language === 'en'}
                                >
                                    EN
                                </button>
                                <span className="lang-sep" aria-hidden="true">/</span>
                                <button
                                    type="button"
                                    className={`lang-btn ${language === 'fr' ? 'is-active' : ''}`}
                                    onClick={() => handleLanguageChange('fr')}
                                    aria-pressed={language === 'fr'}
                                >
                                    FR
                                </button>
                            </div>
                        </div>

                        {/* Search overlay */}
                        <div id="search" className={isSearchActive ? "open" : null}>
                            <span className="close" onClick={handleSearchToggle} />
                            <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                                <div className="input-group">
                                    <input defaultValue="" name="q" type="search" placeholder="Type to search" />
                                    <span className="input-group-btn">
                                        <button type="button" className="search-btn">
                                            <i className="fa fa-search arrow-animation" />
                                        </button>
                                    </span>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
